import { useContent } from "@/context/ContentContext";

export default function SiteFooter() {
  const { content } = useContent();
  return (
    <footer className="border-t border-[#E5E0D8] bg-[#F9F6F0]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-display text-2xl text-[#1A2B3C]">Caldera View Bar Restaurant</div>
          <p className="mt-3 text-sm text-[#8C7A6B] max-w-xs leading-relaxed">
            A quiet corner of Santorini where the volcano, the sea, and the sunset meet a
            long, unhurried Mediterranean dinner.
          </p>
        </div>
        <div>
          <div className="overline">Visit</div>
          <p className="mt-3 text-sm text-[#1A2B3C] leading-relaxed whitespace-pre-line">
            {content.address}
          </p>
        </div>
        <div>
          <div className="overline">Contact</div>
          <ul className="mt-3 space-y-2 text-sm text-[#1A2B3C]">
            {content.phone && <li>Tel · <a className="hover:text-[#D35400]" href={`tel:${content.phone.replace(/\s+/g, "")}`}>{content.phone}</a></li>}
            {content.whatsapp && <li>WhatsApp · <a className="hover:text-[#D35400]" href={`tel:${content.whatsapp.replace(/\s+/g, "")}`}>{content.whatsapp}</a></li>}
            {content.email && <li>Email · <a className="hover:text-[#D35400]" href={`mailto:${content.email}`}>{content.email}</a></li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5E0D8] py-6 text-center text-xs text-[#8C7A6B]">
        © {new Date().getFullYear()} Caldera View Bar Restaurant. All rights reserved.
      </div>
    </footer>
  );
}
